import whatInsideTextImg from './what_inside_text.svg';

/** Figma `Что внутри` (121:15833). */
export function WhatInsideText() {
  return (
    <img
      className="new-delivery-texts__what-inside"
      src={whatInsideTextImg}
      alt=""
      draggable={false}
    />
  );
}
